import { Document, Page, Text, View, Image } from '@react-pdf/renderer'
import klearLogo from '@/assets/logo-klear.png'
import type { KlearFinancialAccount } from '@klear/klear-financial-account/klear-financial-account'
import styles from '@/components/pdf/pdf-styles'

export const WireTransferDetailsDocument = ({
  klearFinancialAccount
}: {
  klearFinancialAccount: KlearFinancialAccount
}) => {
  const companyName = klearFinancialAccount.organization.name
  const routingNumber = klearFinancialAccount.routingNumber
  const accountNumber = klearFinancialAccount.accountNumber
  const line1 = klearFinancialAccount.organization.address?.line1
  const line2 = klearFinancialAccount.organization.address?.line2
  const city = klearFinancialAccount.organization.address?.city
  const state = klearFinancialAccount.organization.address?.state
  const postalCode = klearFinancialAccount.organization.address?.postalCode
  const accountType = 'checking'
  return (
    <Document>
      <Page size="A4">
        <View style={styles.headerLine} />
        <View style={styles.page}>
          <View style={styles.header}>
            <Image src={klearLogo} style={{ width: 90, height: 30 }} />
            <Text style={[styles.lightText, styles.paddingRight10]}>app.klearbusiness.com</Text>
          </View>
          <Text style={[styles.textPadding14, styles.textBold]}>{companyName}</Text>
          <Text>Use these details to send domestic wires and ACH transfers</Text>
          <Text style={styles.textBold}>Domestic Transfer Details</Text>
          <Text>To {companyName}&apos;s Klear account.</Text>
          <Text style={[styles.detailLabel, styles.textPadding14]}>Beneficiary</Text>
          <Text style={styles.detailKey}>Beneficiary Name</Text>
          <Text>{companyName}</Text>
          <Text style={styles.detailKey}>Account Number</Text>
          <Text>{accountNumber}</Text>
          <Text style={styles.detailKey}>Type of Account</Text>
          <Text>{accountType}</Text>
          <Text style={styles.detailKey}>Beneficiary Address</Text>
          <Text>
            {line1}, {city},
          </Text>
          {line2 && <Text>{line2}</Text>}
          <Text>
            {state} {postalCode}
          </Text>
          <Text style={[styles.detailLabel, styles.textPadding14]}>Receiving Bank Details</Text>
          <Text style={styles.detailKey}>ABA Routing Number</Text>
          <Text>{routingNumber}</Text>
          <Text style={styles.detailKey}>Bank Name</Text>
          <Text>Fifth Third Bank N.A.</Text>
          <Text style={styles.detailKey}>Bank Address</Text>
          <Text>
            38 Fountain Square Plaza,{'\n'}
            Cincinnati, OH 45263
          </Text>
          <View style={styles.footer}>
            <Text>
              Klear partners with Stripe Payments Company for money transmission services and account services with
              funds held at <Text style={styles.label}>Fifth Third Bank N.A., Member FDIC</Text>
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}
